/**
 * Small centered stat tile — a muted label over a large colored value.
 * Used for sensor-count and RGB-reading summaries on the status detail
 * panel's custom frame-type renderers.
 *
 * Contains:
 *  - StatMiniCard — default export
 */

import { Card, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

function StatMiniCard({ label, value = null, color }) {
  return (
    <Card variant="outlined" sx={{ textAlign: 'center', p: 1 }}>
      <Typography variant="body2" color="textSecondary">
        {label}
      </Typography>
      <Typography variant="h6" color={color}>
        {value}
      </Typography>
    </Card>
  );
}

StatMiniCard.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node,
  color: PropTypes.string,
};

export default StatMiniCard;
